module.exports = __webpack_public_path__ + "img/shopping-cart-2-line.745aff32.svg";